import { useCallback, useContext, useState } from "react";
import { DataProviderContext, useListContext, useNotify } from "react-admin";
import { ApiManager } from "../data/ApiManager";

interface UseResourceExportOptions {
  exportFormat?: string;
  fileName?: string;
}

export const useResourceExport = (options?: UseResourceExportOptions) => {
  const notify = useNotify();
  const {
    resource,
    currentSort,
    filterValues,
    perPage,
    page,
  } = useListContext();
  const dataProvider = useContext(DataProviderContext) as ApiManager;
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = useCallback(
    async (exportFormatOverride?: string, fileNameOverride?: string) => {
      if (!dataProvider?.exportResource) {
        notify("Export is not available for this resource", "warning");
        return;
      }

      try {
        setIsExporting(true);
        await dataProvider.exportResource(resource, {
          sort: currentSort,
          filter: filterValues,
          pagination: { page, perPage },
          exportFormat: exportFormatOverride ?? options?.exportFormat,
          fileName: fileNameOverride ?? options?.fileName,
        });
      } catch (error) {
        console.error(error);
        notify("Failed to export data", "warning");
      } finally {
        setIsExporting(false);
      }
    },
    [
      currentSort,
      dataProvider,
      filterValues,
      notify,
      options?.exportFormat,
      options?.fileName,
      page,
      perPage,
      resource,
    ]
  );

  return { handleExport, isExporting };
};
